
import * as React from 'react';
import Button from '../../Button';
import { Modal } from '../../Modal';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import {ISeedDivider} from '../../../infrastructure/interfaces'
import './SeedDividerEditorModal.css';

export interface SeedDividerCreatorProps {
  show: any;
  onClose: any;
  selectedDivider: ISeedDivider | undefined,
  onSubmit(divider: ISeedDivider, formData: FormData): void;
}

export interface SeedDividerCreatorState {
  hasRequiredFields: boolean;
  imageFormData?: FormData;
}

export default class SeedDividerEditorModal extends React.Component<SeedDividerCreatorProps, SeedDividerCreatorState> {

  constructor(props: SeedDividerCreatorProps) {
    super(props);
    this.state = {
      imageFormData: undefined,
      hasRequiredFields: false
    };
  }

  validateInput() {
    const hasValidDivider = this.props.selectedDivider != undefined
    const hasValidImages = this.state.imageFormData != undefined
    this.setState({
        hasRequiredFields: hasValidDivider && hasValidImages
    })
}

  closeModal() {
      this.props.onClose();
  }

  handleChange(selectorFiles: FileList | null)
  {
    if (selectorFiles != null) {
      for (var key in selectorFiles) {
        if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
          var imageFormData = new FormData();
          imageFormData.set(ImageFileTypes.SEED_DIVIDER, selectorFiles[key]);
          this.setState({
              imageFormData
            }, () => this.validateInput());
          break;
        }
      }
    }
  }

  render() {
    return (
        <Modal show={this.props.show}
          onClose={() => {this.closeModal();}}
        >
            <Modal.Header>
                <Modal.Title>
                    <h5>
                        {'Upload Seed Separator'}
                    </h5>
                </Modal.Title>
                <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="seedDividerInputContainer">
                    <div className="seedDividerInputRow">
                        <label className="seedDividerInfoLabel">
                            Image (JPEG, 8.5"x11")
                        </label>
                        <input type="file" className="filepond" onChange={(e) => this.handleChange(e.target.files)} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
                    Cancel
                </Button>
                <Button
                    bsClass="primary"
                    disabled={!this.state.hasRequiredFields}
                    onClick={() => {
                        if (!!this.state.imageFormData && !!this.props.selectedDivider) {
                            this.props.onSubmit(this.props.selectedDivider, this.state.imageFormData);
                            this.setState({
                                imageFormData: undefined,
                                hasRequiredFields: false,
                            })
                        }
                    }}
                >
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/SeedDividerEditorModal/SeedDividerEditorModal.tsx